import { invert } from 'underscore';
export const INTERACTIVE_OBJECT_TYPE_ID = '0-91';
export const PROPERTIES_TO_CRM = {
  AUDIENCE_TARGETING_ID: 'hs_audience_targeting_id',
  CAMPAIGN_GUID: 'hs_marketing_campaign_guid',
  CONTAINER_TYPE: 'hs_container_type',
  CONTENT_ID: 'hs_content_id',
  CREATED_AT: 'hs_createdate',
  CREATED_BY_USER_ID: 'hs_created_by_user_id',
  CRM_ID: 'hs_unique_object_id',
  ID: 'hs_object_id',
  IS_ARCHIVED: 'hs_is_archived',
  LAST_MODIFIED: 'hs_lastmodifieddate',
  NAME: 'hs_name',
  OBJECT_ID: 'hs_object_id',
  PERSONALIZATION_STRATEGY_ID: 'hs_personalization_strategy_id',
  PUBLISH_DATE: 'hs_publish_date',
  PUBLISHED_AT: 'hs_published_at',
  PUBLISHED_BY_USER_ID: 'hs_published_by_user_id',
  SCREENSHOT_URL: 'hs_screenshot_url',
  STATE: 'hs_publish_state',
  TRIGGERS: 'hs_triggers',
  UPDATED_AT: 'hs_updated_at',
  UPDATED_BY_USER_ID: 'hs_updated_by_user_id',
  IS_SMART: 'hs_is_smart_cta',
  LOCATIONS: 'hs_cosindex_parent_count',
  AB_TEST_ID: 'hs_ab_test_id',
  IS_ACTIVE_AB_TEST: 'hs_is_active_ab_test',
  IS_SIMPLE_CTA: 'hs_is_simple_cta',
  // permissions
  TEAM_PERMS: 'hs_all_team_ids',
  USER_PERMS: 'hs_user_ids_of_all_owners',
  // roll up properties
  VIEWS: 'hs_views',
  CLICKS: 'hs_clicks',
  SUBMISSIONS: 'hs_clicks_via_form_submission',
  SUBMISSIONS_RATE: 'hs_submissions_rate',
  ATTRIBUTED_SUBMISSIONS: 'hs_attributed_form_submissions',
  ATTRIBUTED_SUBMISSIONS_RATE: 'hs_attributed_form_submission_rate',
  CLICK_RATE: 'hs_click_rate',
  INTERACTIONS: 'hs_interactions'
};
export const CRM_PROPERTIES = Object.values(PROPERTIES_TO_CRM);
export const CRM_TO_PROPERTIES = invert(PROPERTIES_TO_CRM);
export const DEFAULT_COLUMN_KEYS = [PROPERTIES_TO_CRM.NAME, PROPERTIES_TO_CRM.VIEWS, PROPERTIES_TO_CRM.CLICKS, PROPERTIES_TO_CRM.SUBMISSIONS, PROPERTIES_TO_CRM.INTERACTIONS, PROPERTIES_TO_CRM.CLICK_RATE, PROPERTIES_TO_CRM.SUBMISSIONS_RATE, PROPERTIES_TO_CRM.UPDATED_AT, PROPERTIES_TO_CRM.PERSONALIZATION_STRATEGY_ID];
export const AVAILABLE_COLUMNS = [...DEFAULT_COLUMN_KEYS, PROPERTIES_TO_CRM.PUBLISHED_AT, PROPERTIES_TO_CRM.PUBLISH_DATE, PROPERTIES_TO_CRM.CREATED_AT, PROPERTIES_TO_CRM.CAMPAIGN_GUID, PROPERTIES_TO_CRM.LAST_MODIFIED, PROPERTIES_TO_CRM.LOCATIONS, PROPERTIES_TO_CRM.ATTRIBUTED_SUBMISSIONS, PROPERTIES_TO_CRM.ATTRIBUTED_SUBMISSIONS_RATE, PROPERTIES_TO_CRM.PERSONALIZATION_STRATEGY_ID];
export const AVAILABLE_FILTERS = [PROPERTIES_TO_CRM.NAME, PROPERTIES_TO_CRM.CONTAINER_TYPE, PROPERTIES_TO_CRM.CAMPAIGN_GUID, PROPERTIES_TO_CRM.STATE, PROPERTIES_TO_CRM.VIEWS, PROPERTIES_TO_CRM.CLICKS, PROPERTIES_TO_CRM.SUBMISSIONS, PROPERTIES_TO_CRM.INTERACTIONS, PROPERTIES_TO_CRM.CREATED_AT, PROPERTIES_TO_CRM.PUBLISHED_AT, PROPERTIES_TO_CRM.PUBLISH_DATE, PROPERTIES_TO_CRM.UPDATED_AT, PROPERTIES_TO_CRM.LOCATIONS, PROPERTIES_TO_CRM.AB_TEST_ID];
export const AVAILABLE_GALLERY_PROPERTIES = [...AVAILABLE_COLUMNS, PROPERTIES_TO_CRM.SCREENSHOT_URL, PROPERTIES_TO_CRM.STATE];
export const VALID_STATE_VALUES = ['all', 'draft', 'published', 'archived'];
export const OLD_VERSION_SCREENSHOT_TIMESTAMP = 1660732430074;
export const STATIC_COLUMNS = [PROPERTIES_TO_CRM.NAME];
export const GALLERY_STATIC_PROPERTIES = [{
  propertyName: PROPERTIES_TO_CRM.SCREENSHOT_URL,
  order: 0,
  propertyType: 'general'
}, {
  propertyName: PROPERTIES_TO_CRM.NAME,
  order: 1,
  propertyType: 'general'
}];